import { Component } from '@angular/core';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { ButtonComponent } from '../../utilities/button/button.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { InputComponent } from '../../utilities/input/input.component';
import { DropdownComponent } from '../../utilities/dropdown/dropdown.component';
import { MembershipService } from '../../services/membership.service';
import { GeneralService } from '../../services/general.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { CommonModule } from '@angular/common';
import { CheckboxGroupComponent } from '../../components/checkbox-group/checkbox-group.component';
import { TableComponent } from '../../components/table/table.component';
import { PaginationComponent } from '../../utilities/pagination/pagination.component';
import { PermissionService } from '../../services/permissions.service';
import { SideModalComponent } from "../../components/side-modal/side-modal.component";

@Component({
  selector: 'app-membership',
  standalone: true,
  imports: [
    DashboardComponent,
    CommonModule,
    ButtonComponent,
    ModalComponent,
    InputComponent,
    DropdownComponent,
    CheckboxGroupComponent,
    TableComponent,
    PaginationComponent,
    SideModalComponent
],
  templateUrl: './membership.component.html',
  styleUrl: './membership.component.scss',
})
export class MembershipComponent {
  inviteType: any = ['Invited Members'];
  currentinviteType: string = 'Invited Members';
  fetchingData: boolean = false;
  membershipDetailsOpen: boolean = false;
  singleMember: any;
  selectedMemberId: string = '';
  tableHeader: any[] = [];
  tableData: any[] = [];
  filterData: any[] = [];
  limit: number = 10;
  page: number = 1;
  fromDate: any;
  invites: any;
  pages: number = 0;
  totalMembers: number = 0;
  totalInvites: number = 0;
  disabledBg: string = 'bg-grey-600';
  enabledBg: string = 'bg-[#081A46]'
  toDate: any;
  emptyTableState = {
    title: 'No data found',
    label: 'You have no invites',
  };
  loading: boolean = false;
  createModalOpen: boolean = false;
  userRoles: any = ['Admin', 'Super Admin'];
  newMember: any = {
    emailAddress: '',
    firstName: '',
    lastName: '',
    roles: [{ role: '', permissions: [] }],
  };
  errors: any = {
    emailAddress: '',
    firstName: '',
    lastName: '',
    roles: '',
  };
  permissions: any = ['Write', 'Delete', 'Update'];

  canWrite = false;
  canDelete = false;
  canUpdate = false;

  constructor(
    private membershipService: MembershipService,
    private generalService: GeneralService,
    private notification: NzNotificationService,
    private permissionService: PermissionService
  ) {
    this.getInvites();
    this.fromDate = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1
    );
    this.toDate = new Date(
      new Date().getFullYear(),
      new Date().getMonth() + 1,
      0
    );
    this.filterData = [
      {
        type: 'date-range',
        name: 'date-range',
        label: 'Date Range',
        fromDate: this.fromDate,
        toDate: this.toDate,
        fromDateValue: '',
        toDateValue: '',
      },
      {
        type: 'select',
        name: 'channel',
        label: 'Channel',
        value: '',
        defaultValue: '',
        options: [
          { key: '', value: 'All' },
          { key: 'wallet', value: 'Wallet' },
          { key: 'card', value: 'Card' },
          { key: 'ussd', value: 'Ussd' },
          { key: 'loyaltyCard', value: 'Loyalty Card' },
          { key: 'onlineTransfer', value: 'Online Transfer' },
        ],
      },
      {
        type: 'select',
        name: 'tansaction-type',
        label: 'Transaction Type',
        value: '',
        defaultValue: '',
        options: [
          { key: '', value: 'All' },
          { key: 'funding', value: 'Funding' },
          { key: 'withdrawal', value: 'Withdraw' },
        ],
      },
      {
        type: 'select',
        name: 'tansaction-status',
        label: 'Transaction Status',
        value: '',
        defaultValue: '',
        options: [
          { key: '', value: 'All' },
          { key: 'failed', value: 'Failed' },
          { key: 'success', value: 'Success' },
          { key: 'pending', value: 'Pending' },
        ],
      },
      {
        type: 'select',
        name: 'transaction-initiator',
        label: 'Transaction Initiator',
        value: '',
        defaultValue: '',
        options: [
          { key: '', value: 'All' },
          { key: 'company', value: 'Company' },
          { key: 'customer', value: 'Customer' },
        ],
      },
    ];
  }

  ngOnInit() {
    this.canWrite = this.permissionService.hasPermission('Write');
    this.canDelete = this.permissionService.hasPermission('Delete');
    this.canUpdate = this.permissionService.hasPermission('Update');
    console.log(this.canDelete, this.canWrite, this.canUpdate);
  }

  setInviteType(type: string) {
    this.currentinviteType = type;
  }
  openCreateModal() {
    this.createModalOpen = true;
  }
  closeCreateModal() {
    this.createModalOpen = false;
  }
  openDetailsModal(id: string){this.membershipDetailsOpen = true; this.selectedMemberId = id;  this.singleMember = this.invites.find((obj: any) => obj._id === id);
    console.log(this.singleMember);}
  closeDetailsModal(){this.membershipDetailsOpen = false}
  handleInput(data: { title: string; value: string }) {
    this.newMember[data.title] = data.value;
    if (data.value === '') {
      this.errors[data.title] = 'Required*';
      return;
    } else {
      this.errors[data.title] = '';
    }
  }
  handleRoleTitle(data: { title: string; value: string }, index: number) {
    this.newMember[data.title][index].role = data.value;
    if (data.value === '') {
      this.errors[data.title] = 'Required*';
      return;
    } else {
      this.errors[data.title] = '';
    }
  }
  handleSelection(selection: { [key: string]: boolean }, index: number) {
    this.newMember.roles[index].permissions = { ...selection };
  }
  removeRole(index: number) {
    if (this.newMember?.roles?.length > 1) {
      this.newMember?.roles.splice(index, 1);
    }
  }
  addRole() {
    this.newMember?.roles.push({
      role: '',
      permissions: [],
    });
  }
  validateForm = () => {
    const errors: any = {};
    if (this.newMember.firstName === '') {
      errors.firstName = 'Required*';
    }
    if (this.newMember.lastName === '') {
      errors.lastName = 'Required*';
    }
    if (this.newMember.emailAddress === '') {
      errors.emailAddress = 'Required*';
    } else if (
      !this.generalService.validateEmail(this.newMember.emailAddress)
    ) {
      errors.emailAddress = 'Please use a valid email*';
    }
    console.log(errors);
    return errors;
  };
  validateFields(obj: any): boolean {
    const isEmpty = (value: any): boolean => {
      return (
        value === '' ||
        value === null ||
        value === undefined ||
        (Array.isArray(value) && value.length === 0)
      );
    };

    const checkObject = (obj: any): boolean => {
      for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          const value = obj[key];

          if (typeof value === 'object' && value !== null) {
            if (Array.isArray(value)) {
              if (
                value.length === 0 ||
                value.some(
                  (item) =>
                    isEmpty(item) ||
                    (typeof item === 'object' && !checkObject(item))
                )
              ) {
                return false;
              }
            } else {
              if (!checkObject(value)) {
                return false;
              }
            }
          } else {
            if (isEmpty(value)) {
              return false;
            }
          }
        }
      }
      return true;
    };

    return checkObject(obj);
  }
  inviteMember() {
    if (!this.validateFields(this.newMember)) {
      this.notification.warning('Please Fill All Fields', '', {
        nzClass: 'notification',
      });
      return;
    }
    this.loading = true;
    this.membershipService.sendInvite(this.newMember).subscribe(
      (res: any) => {
        if (res.statusCode === 200) {
          this.createModalOpen = false;
          this.loading = false;
          console.log(res);
          this.notification.success('Success', 'Invite Sent Successfuly', {
            nzClass: 'notification',
          });
        } else {
          this.createModalOpen = false;
          this.loading = false;
          this.notification.error('Error', 'Failed to Send Invite', {
            nzClass: 'notification',
          });
        }
      },
      (error) => {
        this.createModalOpen = false;
        this.loading = false;
        this.notification.error('Error', 'Failed to Send Invite', {
          nzClass: 'notification',
        });
      }
    );
  }
  getInvites() {
    // this.fetchingData = true;
    this.membershipService.getInvites().subscribe({
      next: (res: any) => {
        console.log('get invites',res);
        this.invites = res.data;
        // this.fetchingData = false;
        this.totalMembers = res?.pagination?.total;
        this.limit = res?.pagination?.limit;
        this.page = res?.pagination?.page;
        this.pages = res?.pagination?.pages;
        // if (this.apiKeys.length == 0) this.emptyState = true;
        this.tableHeader = [
          { name: 'Relay Name', ratio: { width: '33%', minWidth: '204px' } },
          {
            name: 'Email Address',
            ratio: { width: '33%', minWidth: '83px' },
          },
          { name: 'Role', ratio: { width: '33%', minWidth: '83px' } },
        ];
        this.tableData = this.invites.map((invite: any, n: number) => {
          return [
            {
              name: {
                title: (invite.firstName) + ' ' + (invite.lastName),
                label: this.generalService.formatDate(invite.createdAt),
              },
              ratio: { width: '33%', minWidth: '180px' },
              id: invite._id,
            },
            {
              name: {
                title: `<span class="font-[500]">${invite.emailAddress}</span>`,
              },
              ratio: { width: '33%', minWidth: '50px' },
              id: invite._id,
            },
            {
              name: {
                title: `<span class="capitalize">${invite.membership.roles[0].role}&nbsp;</span><span></span>`,
              },
              ratio: { width: '33%', minWidth: '50px' },
              id: invite._id,
            },
          ];
        });
      },
      error: (err) => {
        // this.fetchingData = false;
      },
    });
  }
  manageRoute(data: any) {}
  search(value: any) {}
  changeLimit(limit: any) {}
  applyFilter(data: any) {}
  refreshList() {}
}
